/**
 * Merge expected roster ids with ids that already submitted responses.
 * Prevents "N of 1 submitted" when the roster lags behind real submissions.
 */

export function mergeParticipantRoster(
  rosterIds: string[] | null | undefined,
  responseParticipantIds: string[] | null | undefined,
): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const id of [...(rosterIds ?? []), ...(responseParticipantIds ?? [])]) {
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}

export function resolveParticipantTotal(
  rosterIds: string[] | null | undefined,
  responseParticipantIds: string[] | null | undefined,
): number {
  return Math.max(mergeParticipantRoster(rosterIds, responseParticipantIds).length, 1);
}
